export default __webpack_public_path__ + "static/media/ka-bg-ph.098906eb.jpg";